import { Routes, Route, Navigate } from 'react-router-dom';
import { useApp } from './context/AppContext';
import LoginPage from './components/LoginPage';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import CreateFeaturePage from './components/CreateFeaturePage';
import FeatureDetailPage from './components/FeatureDetailPage';
import ProjectSettingsPage from './components/ProjectSettingsPage';
import AuditLogPage from './components/AuditLogPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user } = useApp();
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  const { user } = useApp();

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/projects" replace />} />
        <Route path="projects/:projectId/flags" element={<Dashboard />} />
        <Route path="projects/:projectId/flags/new" element={<CreateFeaturePage />} />
        <Route path="projects/:projectId/flags/:flagId" element={<FeatureDetailPage />} />
        <Route path="projects/:projectId/settings" element={<ProjectSettingsPage />} />
        <Route path="projects/:projectId/audit" element={<AuditLogPage />} />
        <Route path="projects" element={<Dashboard />} />
      </Route>
    </Routes>
  );
}
